import React, { Component } from 'react';
import axios, {AxiosResponse} from 'axios';
import emailjs from 'emailjs-com';
const qs = require('querystring');

class Form extends Component {
  constructor(){
      super();
      this.state = {
          name : "",
          email : "",
          message : "",
          formError: false,
          msjError: "",
          msjSucces: "",
          formSuccess: false
      }
  }

  getName = (e) =>{
    let username = e.target.value; 
    this.setState({
        name: username
    });
    console.log(this.state.name);
  }
  
  
  getEmail = (e) =>{
    let userEmail = e.target.value; 
    //the most important thing is that we use a RegEx
    //in order to manage the input of the email
    //at least we can get a some what valid email
    if(userEmail.match(/^([a-zA-Z0-9_]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)){
      this.setState({formError: false})
      this.setState({email: userEmail});
      }else{
        this.setState({email: "" });
      console.log("E");
      this.setState({msjError: 'Email incorrecto, verifica el email ingresado'}); 
       this.setState({formError: true})
    }
    console.log(this.state.email);
  }

  
  getDescription = (e) =>{
    let userMessage = e.target.value; 
    this.setState({
        message: userMessage
    });
    console.log(this.state.message);
  }
  //send the form
  submitForm = (e) =>{
    e.preventDefault();
    console.log('Entro en el submit');
    if(this.state.name === "" || this.state.email === "" || this.state.message === "" ){
      this.setState({
        msjError: "Todos los datos del formulario son requeridos."
     })
      this.setState({
        formError: true
     })
       return false;
    }else{
        this.setState({formError: false})
        this.setState({msjSucces: "Tu mensaje ha sido enviado."})  
        this.setState({formSuccess: true})
        console.log(`UserData: {
            Username: ${this.state.name},
            Email: ${this.state.email},
            Message: ${this.state.message}
        }`)
        const requestBody = {
          "name": this.state.name,
          "email": this.state.email,
          "mensaje": this.state.message
        }
        emailjs.send('default_service','email_contact', requestBody, 'user_QAk2zSKJlwPolF6lTjc8j')
        .then((response) => {
              console.log('SUCCESS!', response.status, response.text)
        }, (err) => {
              console.log('FAILED...', err);
        });
    }
 
  }
  render() {

  

    return (
        <form refs="frmContact">
          {/* I am just sending a basic error message */}
              {this.state.formError &&
                <p className="error">
                    {this.state.msjError }
                </p>
              }
              {this.state.formSuccess &&
                <p className="success">
                    {this.state.msjSucces }
                </p>
              }
              <p>Por favor completa el siguiente formulario para contactarte.</p>
              <div>
                <label htmlFor="name">Nombre</label>
                <input type="text" name="name" placeholder="Escribe tu nombre" onBlur={this.getName} />
              </div>
              <div>
                <label htmlFor="email">Correo</label>
                <input type="email" name="email" placeholder="Escribe tu correo electrónico para contactarte" onBlur={this.getEmail} />
              </div>
              <div>
                <label htmlFor="name">Mensaje</label>
                <textarea onBlur={this.getDescription} maxLength="450" placeholder="Escribe tu mensaje" style={{height:'150px'}}></textarea>

              </div>
              <div>
                <p>Nos pondremos en contacto lo más pronto posible</p>
                <input type="submit" name="submit" value="Enviar" onClick= {this.submitForm} />

              </div>
              
            </form>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/form.js